<template>
  <v-app>
    <v-dialog
        v-model="dialog"
        max-width="700"
        persistent
    >
      <v-card>
        <v-toolbar dark>
          <v-card-title class="headline">
             Add book
            <hr>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-spacer></v-spacer>
            <v-btn icon  @click="closeDialog">
              <i class="fas fa-times"></i>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field @input="validateBookBarCode(book.book_barcode_no)" outlined dense label="Barcode number"
                              v-model="book.book_barcode_no" autocomplete="off"></v-text-field>
                <span class="text-danger" v-if="$v.book.book_barcode_no.$error">This information is required</span>
                <span class="text-danger" v-if="exist">{{ exist.msg }}</span>
              </v-col>
              <v-col cols="12" v-if="!exist">
                <v-text-field outlined dense label="Title" v-model="book.title" autocomplete="off"></v-text-field>
                <span class="text-danger" v-if="!exist && $v.book.title.$error">This information is required</span>
              </v-col>
              <v-col cols="12">
                <v-text-field type="number" outlined dense label="Quantity" v-model="book.total_quantity"
                              autocomplete="off"></v-text-field>
                <span class="text-danger" v-if="$v.book.total_quantity.$error">This information is required</span>
              </v-col>
            </v-row>
            <v-col cols="6" md="4">
              Status
              <v-switch v-model="book.is_active"
                  :label="book.is_active?'Active':'Inactive'"
                  color="primary">
              </v-switch>
            </v-col>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn class="btn btn-standard cancel-btn" depressed @click="closeDialog">Cancel</v-btn>
              <v-btn v-if="!exist"  class="text-white ml-2 btn btn-primary"
                     depressed @click="createBook" :loading="loading">Save</v-btn>
              <v-btn v-else  class="text-white ml-2 btn btn-primary"
                     depressed @click="updateBookByBarcode">Update</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import BookMixin from "@/mixins/BookMixin";
import BookService from "@/core/services/library/book/BookService";

const book = new BookService();
export default {
  name: "NewBook",
  mixins: [BookMixin],
  validations() {
    return {
      book: this.rule
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      book: {
        book_barcode_no: null,
        title: null,
        total_quantity: null,
        is_active:true,
      }
    }
  },
  computed: {
    rule() {
      let book = {
        book_barcode_no: {required},
        total_quantity: {required},
      }
      if (!this.exist)
        book.title = {required};
      return book;
    },
  },
  methods: {
    openDialog() {
      this.dialog = true;
      this.resetForm();
    },
    closeDialog() {
      this.dialog = false;
      this.resetForm();
    },
    createBook() {
      this.$v.$touch()
      if (this.$v.$error) {
        setTimeout(() => {
          this.$v.$reset();
        }, 3000)
      } else {
        let fd = new FormData();
        fd.append('title', this.book.title)
        fd.append('total_quantity', this.book.total_quantity)
        fd.append('book_barcode_no', this.book.book_barcode_no)
        this.loading = true
        book.store(this.book).then(response => {
          this.redirectTo(response.data.book.id);
          this.resetForm();
          this.loading = false
        }).catch(() => {
          this.loading = false
        });
      }
    },
    updateBookByBarcode() {
      this.$v.$touch()
      if (this.$v.$error) {
        setTimeout(() => {
          this.$v.$reset();
        }, 3000)
      } else {
        this.updateByBarcodeNo(this.book.book_barcode_no, this.book)
        this.resetForm();
      }
    },
    resetForm() {
      this.book = {
        book_barcode_no: null,
        title: null,
        total_quantity: null,
        is_active: true,
      }
    },
    redirectTo(id) {
      this.$router.push({name: 'book-detail', params: {id: id}})
    }
  }
}
</script>
